<template>
  <div class="full">
    <div class="heading" v-if="heading">{{ heading }} :</div>
    <div
      class="select-box"
      :style="{
        width: width,
        height: height,
      }"
      v-clickout="
        () => {
          handleClickOut(search);
          visible = false;
          search = '';
        }
      "
      :class="{ active: visible }"
    >
      <div
        v-if="disabled"
        class="selected-item"
        :style="{
          border: borderEnable
            ? '0.0625em solid rgba(255,255,255,0.3)'
            : 'none',
        }"
        :class="classArray"
      >
        <div class="selected-item-text disabled" v-if="multiSelectTitle">
          {{ multiSelectTitle }}
        </div>
        <div
          class="selected-item-text disabled"
          v-else
          v-tooltip:right.ellipsis="getCurrentValue || ''"
          :class="[boldActive ? 'semiBold' : '']"
        >
          {{ getCurrentValue || this.$t('selectFromAvailable') }}
        </div>
      </div>
      <!-- <div
        class="selected-item"
        @click="visible = !visible"
        v-tooltip:right="current.label || ''"
      > -->
      <div
        v-else
        class="selected-item"
        @click="onOptionsOpen"
        :style="{
          width: width,
          border: borderEnable
            ? '0.0625em solid rgba(255,255,255,0.3)'
            : 'none',
        }"
        :class="classArray"
        :id="id"
      >
        <div class="selected-item-text" v-if="multiSelectTitle">
          {{ multiSelectTitle }}
        </div>
        <div
          class="selected-item-text"
          v-else
          v-tooltip:right.ellipsis="getCurrentValue || ''"
          :class="[boldActive ? 'semiBold' : '']"
        >
          {{ getCurrentValue || this.$t('selectFromAvailable') }}
        </div>
        <button
          class="btn-"
          :style="`transform: rotate(${visible ? 180 : 0}deg)
            transform: translateY(2px);
          `"
          :id="`btn-arrow-down-${id}`"
        >
          <BaseIcon name="arrowDown" height="0.8em" width="0.8em" />
        </button>
      </div>
      <div class="search-sel" v-show="visible">
        <div v-if="isSearch" div class="search-sel-box">
          <input
            type="text"
            class="search-sel-search"
            :value="search"
            @input="onSearchChange"
            :placeholder="searchPlaceholder || $t('search')"
            :id="`input-search-sel-${id}`"
            ref="searchInput"
          />
          <div class="search-select-search-actions">
            <button
              @click="
                (e) => {
                  e.stopPropagation();
                  $emit('onSearch', search);
                }
              "
              v-if="displaySearchIcon && !isSearchLoading"
              id="search-select-search-btn"
              class="search-select-search-btn"
            >
              <BaseIcon name="search" width="1rem" height="1rem" />
            </button>
            <Loading
              v-if="displaySearchIcon && isSearchLoading"
              :smallar="true"
              class="search-select-search-loader"
            />
            <button
              @click="onClear"
              v-if="search"
              id="btn-close-btn"
              class="close-btn"
            >
              <BaseIcon name="closeButton-mini" />
            </button>
          </div>
        </div>
        <div v-if="displaySelectedList">
          <RexMultiSelectedOptions
            class="selected-list-box"
            :options="selectedList"
            :stopPropagation="true"
            @getDeleteOption="(optn) => $emit('onRemoveOption', optn)"
          />
        </div>
        <div
          class="option-wrapper"
          v-if="multiSelect"
          @scroll="onMultiSelectOptionScroll"
        >
          <div
            class="option"
            :class="{
              'select-disabled':
                selectedOpt.includes(i.key) ||
                (disableSelection && !i.selected),
            }"
            :style="{ width: '98%' }"
            v-for="(i, index) in multiSelectData"
            :key="index"
            @click="handleMultipleSelect(i, index)"
            v-tooltip:bottom.ellipsis="getItemValue(i) || ''"
            :id="`${id}-${i.label}-multi`"
          >
            <!--

		@binding {string} name name of the icon item
	-->
            <span>
              <BaseIcon :name="multiSelectIcon" v-if="i.selected" />
              <span style="margin-left: 1.31rem" v-else></span>
            </span>
            {{ getItemValue(i) }}
          </div>
          <Loading
            v-if="isNextPageLoading && !isSearchLoading"
            :smallar="true"
            class="search-select-search-loader"
          />
        </div>
        <div class="option-wrapper" v-else @scroll="onMultiSelectOptionScroll">
          <div class="option" v-for="(i, index) in filterData" :key="index">
            <span class="option-icon">
              <span
                class="selected-item-text"
                @click="handleSelect(i)"
                v-tooltip:bottom.ellipsis="getItemValue(i) || ''"
                :id="`${id}-${index}-single`"
              >
                {{ getItemValue(i) }}
                <BaseIcon
                  class="align-icon"
                  v-if="i.icon"
                  :name="i.icon"
                  width="1rem"
                  height="1rem"
                />
              </span>
              <!--checkHide hides the action icon for the default dashboard -->
              <span v-if="actions && checkHide(i)">
                <span v-for="(icon, index) in icons" :key="index" class="icon">
                  <span
                    @click="emitValue(icon, i)"
                    :id="`${id}-${i.name}-icon-${icon.iconName}`"
                  >
                    <BaseIcon
                      :name="icon.iconName"
                      :width="icon.width"
                      :height="icon.height"
                    />
                  </span>
                </span>
              </span>
            </span>
          </div>
          <Loading
            v-if="isNextPageLoading && !isSearchLoading"
            :smallar="true"
            class="search-select-search-loader"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RexMultiSelectedOptions from '@/rex-components/rex-multi-selected-options.vue';
import Loading from '@/rex-components/rex-loading.vue';
import { mapGetters } from 'vuex';
import { nextTick } from 'vue';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import {
  SELECT_FIELD_DEBOUNCE_DURATION_IN_MS,
  SELECT_FIELD_THROTTLE_DURATION_IN_MS,
} from '@/utils/constants';

/**
 * The only true select dropdown .
 * @displayName RexSelect
 */
export default {
  components: { RexMultiSelectedOptions, Loading },
  name: 'RexSearchSelect',
  props: {
    /**
     * The data to be passed on the select
     * The data format will be of array of objects
     */
    data: { type: Array },
    /**
     * Currently selected object
     *
     */
    current: {},
    /**
     * Heading of the select dropdown
     *
     */
    heading: { type: String, default: '' },
    /**
     * The placeholder value for the search bar
     *
     */
    searchPlaceholder: { type: String },
    /**
     * If the select is disabled
     *
     */
    disabled: { type: Boolean, default: false },
    /**
     * If the sleect is multiselect
     *
     */
    multiSelect: { type: Boolean, default: false },
    /**
     * The width of the dropdown
     *
     */
    width: { type: String, default: '20.75em' },
    /**
     * multiSelectTitle to be displayed on the select
     * @example <caption>Choose applications</caption>
     *
     */
    height: { type: String, default: '' },
    multiSelectTitle: { type: String },
    /**
     * objectValueIndex is the index of the values that to be showed when there are muliple key value pairs in the object
     *
     *
     */
    objectValueIndex: {},

    /**
     * borderEnable is the indicator for displaying border
     *
     *
     */
    borderEnable: { type: Boolean, default: true },
    /**
     *boldActive will bold the selected option
     *
     *
     */ boldActive: { type: Boolean, default: false },
    /**
     * isSearch is the toggle for displaying search
     *
     *
     */

    isSearch: { type: Boolean, default: true },

    /**
     * multiSelectIcon is for the custom icon for multiselect
     *
     */
    multiSelectIcon: { type: String, default: 'check' },
    /**
     * icons conatins the array with the following definition which cabn be used for actions such as edit or delete
     * @example
     * [
        {
          emitName: 'Edit',
          iconName: 'editFilled',
          width: '1em',
          height: '1em'
        },
        {
          emitName: 'Delete',
          iconName: 'deleteFilled',
          width: '1em',
          height: '1em'
        }
      ]
     */
    icons: {
      type: Array,
      default: () => [
        {
          emitName: 'Edit',
          iconName: 'editFilled',
          width: '1em',
          height: '1em',
        },
        {
          emitName: 'Delete',
          iconName: 'deleteFilled',
          width: '1em',
          height: '1em',
        },
      ],
    },
    actions: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    classArray: { type: Array, default: () => [] },
    id: {
      type: String,
      required: true,
    },
    /**
     * enable the below key if the selected state needs to be maintained from parent
     *
     *
     */
    useParentData: {
      type: Boolean,
      default: false,
    },
    /**
     * enable this to perform action on search click
     * emits $onSearch event
     *
     *
     */
    enableSearchBtn: {
      type: Boolean,
      default: false,
    },
    /**
     * loader can be displayed while performing
     * search operation
     *
     *
     */
    isSearchLoading: {
      type: Boolean,
      default: false,
    },
    /**
     * Display selected options
     * emits $onRemoveOption event
     *
     */
    enableSelectedList: {
      type: Boolean,
      default: false,
    },
    /**
     * Provide the selected
     * options list
     *
     */
    selectedList: {
      type: Array,
      default: () => [],
    },
    disableSelection: {
      type: Boolean,
      default: false,
    },
    isNextPageLoading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      search: '',
      visible: false,
      dropdownData: [],
      lastScrollTop: 0,
    };
  },

  methods: {
    /**
     * Gets called whenver the user clicks on select dropdown
     *
     * @param {object} i selected object
     */
    handleSelect(i) {
      this.$emit('onChoose', i);
      this.visible = false;
    },
    /**
     * Will return the exact value of the object
     *
     * @param {object} item ith object in the array
     */
    keyFinder(item) {
      return Object.values(item).length > 1
        ? this.objectValueIndex
          ? Object.values(item)[this.objectValueIndex]
          : Object.values(item)[0]
        : Object.values(item)[0];
    },
    /**
     * Will return the dropdown value
     *
     * @param {object} item ith object in the array
     */
    getItemValue(item) {
      return this.keyFinder(item);
    },
    /**
     * Gets called whenver the user clicks on action item in dropdown
     *
     * @param {object} icon icon contains the information regarding the selected icon
     * @param {object} item selected object
     */
    emitValue(icon, item) {
      /**
       *  Triggers when clicked event.
       *
       * @event onCLick
       *@property {object} item selected object
       */

      this.$emit(`on${icon.emitName}`, item);
    },

    /**
     * Gets called whenver the user clicks on multiple select dropdowns
     *
     * @param {object} item selected object
     * @param {Number} index the index of the data array
     */
    handleMultipleSelect(item, index) {
      if (this.useParentData) {
        this.$emit('onMultiSelect', item);
        return;
      }
      for (var data in this.dropdownData) {
        if (this.dropdownData[data].key == item.key) {
          this.dropdownData[data].selected = !this.dropdownData[data].selected;
        }
      }
      this.$emit(
        'onMultiSelect',
        this.dropdownData?.filter((item) => item.selected == true),
      );
    },
    /**
     * Hiding the action icons for default dashboard
     */
    checkHide(item) {
      if (item.id != 'default' && !item.isBeta) {
        return true;
      } else return false;
    },
    handleClickOut(search) {
      if (this.enableSearchBtn && search?.length > 0)
        this.$emit('onSearch', '');
    },
    onClear() {
      this.search = '';
      if (this.enableSearchBtn) this.$emit('onSearch', '');
    },
    onSearchChange: debounce(function (event) {
      this.search = event.target.value;
      this.$emit('onSearch', this.search);
    }, SELECT_FIELD_DEBOUNCE_DURATION_IN_MS),
    onMultiSelectOptionScroll: throttle(function (e) {
      const { scrollHeight, scrollTop, clientHeight } = e.srcElement;

      if (
        !this.isNextPageLoading &&
        Math.abs(scrollHeight - clientHeight - scrollTop) <= 1 &&
        this.data.length < this.total
      ) {
        this.$emit('fetchMore', this.search);
      }
    }, SELECT_FIELD_THROTTLE_DURATION_IN_MS),
    onOptionsOpen() {
      this.visible = !this.visible;
      if (this.$refs.searchInput)
        nextTick(() => this.$refs.searchInput.focus());
    },
  },
  computed: {
    /**
     ******************************
     * @deprecated
     ******************************
     */
    selectedOpt() {
      return '';
    },
    // Work under progress
    showTooltip() {
      return this.keyFinder(this.current).length > 42 ? true : false;
    },
    filterData() {
      return this.data?.filter((i) => {
        if (typeof this.keyFinder(i) === 'string') {
          return (
            this.keyFinder(i)
              .toUpperCase()
              .indexOf(this.search.toUpperCase()) !== -1
          );
        } else return i;
      });
    },
    multiSelectData() {
      return this.dropdownData?.filter((i) => {
        if (this.enableSearchBtn) return true;
        if (typeof this.keyFinder(i) === 'string') {
          return (
            this.keyFinder(i)
              .toUpperCase()
              .indexOf(this.search.toUpperCase()) !== -1
          );
        } else return i;
      });
    },

    getCurrentValue() {
      if (typeof this.current === 'object' && this.current !== null) {
        return this.keyFinder(this.current);
      } else return this.current;
    },
    displaySearchIcon() {
      return this.enableSearchBtn && this.search && this.search.length > 0;
    },
    displaySelectedList() {
      return (
        this.enableSelectedList &&
        this.selectedList &&
        this.selectedList.length > 0
      );
    },
  },
  mounted() {
    if (this.multiSelect) {
      if (!this.isEdit) {
        this.dropdownData = this.data?.map((item) => {
          const newItem = { ...item, selected: false };
          return newItem;
        });
      } else {
        this.dropdownData = this.data?.map((item) => {
          //     const newItem = { ...item, selected: false };
          return item;
        });
      }
    } else {
      this.dropdownData = this.data?.map((item) => {
        //     const newItem = { ...item, selected: false };
        return item;
      });
    }

    //  this.dropdownData = [...this.data];
  },
  watch: {
    data(newVal) {
      if (this.useParentData) {
        this.dropdownData = newVal;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.full {
  @include flex-center-justify(flex-start);
}
.heading {
  @include heading-text;
  margin-right: 0.5625em;
}
.select-box {
  position: relative;
  border-radius: 0.1875em;
  height: 2.5em;
  .icon {
    flex-shrink: 0;
  }
  .selected {
    display: inline-block;
    padding: 0.3125em;
    border-radius: 0.1875em;
    margin: 0.1875em;
    overflow: hidden;
  }
  .remove-icon {
    display: inline-block;
    margin-left: 0.3125em;
    cursor: pointer;
  }
}
.selected-item-text {
  width: 100%;
  // @include truncate(21em);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.selected-item {
  height: 100%;
  width: 100%;
  padding-left: 0.9375em;
  overflow: auto;
  @include flex-center-justify;
  // border: 0.0625em solid $border-primary;
  border-radius: 0.1875em;
  color: $font-primary;
}
.search-sel {
  position: absolute;
  margin-top: 0.3125em;
  width: 100%;
  // width: 11.8125em;
  top: 100%;
  left: 0;
  background: $bg-secondary;
  color: $font-primary;
  border-radius: 0.375em;
  border-right-width: 0.0625em !important;
  text-align: left;
  @include active-state;

  z-index: 499;
  .close-btn {
    @include btn-fill($font-primary);
    margin: 0.3125em;
    display: flex;
  }
}
.active {
  @include active-state;
}

.option {
  padding: 0em 0.9375em;
  line-height: 2.25em;
  margin: 0.125em 0.125em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: $font-primary;

  &:hover {
    background-color: $color-brand-accent;
    color: $font-contrast;
    cursor: pointer;
  }
  .option-icon {
    @include flex-center-justify(space-between);
  }
  .icon {
    margin-right: 1.125em;
    fill: $color-brand-accent;
    &:last-child {
      margin-right: 0px;
    }
  }
}
.search-sel-search {
  width: 100%;
  border: 0;
  outline: 0;
  padding: 0.4375em 1.5625em 0.4375em 0.625em;
  background-color: $bg-secondary;
  color: $font-primary;
}
.option-wrapper {
  overflow: auto;
  max-height: 12.5em;
  padding-bottom: 0.125em;
}
.btn- {
  @include btn-fill($font-primary);
  padding: none;
  margin: 0px 0.275em;
}
.search-sel-box {
  @include flex-center-justify(space-between);
  margin: 0.3125em;
  height: 3rem;
  border-radius: 0.1875em;
  border: 0.0625em $border-primary solid;
}

.option:first-child > .option-icon > .actions {
  display: none;
}
.option:hover .icon {
  fill: $font-contrast !important;
}
.semiBold {
  font-family: $semi-bold;
}
.disabled {
  color: $border-color-primary-disabled;
}
.search-select-search-actions {
  @include flex-center-vert;
}
.search-select-search-btn {
  border-radius: 0.5375rem;
  border: none;
  fill: $color-brand-accent;
  background-color: inherit;
  margin-left: 0.3125em;
  cursor: pointer;
}
.selected-list-box {
  display: flex;
  flex-wrap: wrap;
  background-color: $bg-dark-black;
  max-height: 8rem;
  overflow: scroll;
  padding-left: 0.5rem;
  padding-top: 0.75rem;
}
.search-select-search-loader {
  transform: scale(0.65);
}
.select-disabled {
  color: $button-disabled-light;
  cursor: not-allowed;
  pointer-events: none;
}
:deep(.option-btn) {
  margin: 0rem 0.5rem 0.5rem 0rem;
}
:deep(.optn-text) {
  width: 3.5rem;
}
.align-icon {
  margin-right: 0.5em;
  @include svg-fill($color-active-blue);
  vertical-align: super;
}
</style>
